export default "__VITE_ASSET__BN9udgaF__"